/* eslint-disable array-callback-return */
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import { customTheme } from "../../../assets/scss/theme/Theme";
import { ThemeProvider } from "@mui/material/styles";
import * as CommonStyles from "./CommonStyles";
import "./CommonStyles.scss";
import { ControlType } from "../../../constants/app.constant";

interface Props {
  name: string;
  title: string;
  description: string;
  controls: any;
  values?: any;
  onChange: any;
  width?: number;
}

const MultipleInput: FC<Props> = ({
  name,
  title,
  description,
  controls = [],
  values = {},
  width = "300px",
  onChange
}) => {
  const { t } = useTranslation();
  return (
    <Box className="filter-section multiple-input-control">
      <h4 style={CommonStyles.titleElement}>{t(title)}</h4>
      <Typography sx={CommonStyles.descriptionElement}>
        {t(description)}
      </Typography>

      <Box className="input-controls-wrapper">
        {controls.map((control: any, index: number) => {
          if (control.controlType === ControlType.NUMERIC) {
            return (
              <TextField
                key={`input-${name}-numeric-${control.name}`}
                name={name}
                style={{ width: width }}
                type="number"
                helperText={control.helperText || ""}
                placeholder={control.placeholder || ""}
                InputProps={{
                  inputProps: { min: control.min, max: control.max }
                }}
                size="small"
                fullWidth
                value={values[control.name]}
                onChange={(e) => {
                  onChange(e, name, control.name);
                }}
              />
            );
          }
        })}
      </Box>
    </Box>
  );
};

export default MultipleInput;
